<button
  class="card-button group flex items-center w-full h-[99px] p-4 border rounded-2xl bg-table shadow-base cursor-pointer"
  (click)="onAction()"
  [disabled]="config.disabled"
>
  <div class="flex flex-col gap-2 w-full">
    <div class="flex items-center gap-2">
      <div
        class="card-button__icon flex items-center justify-center w-6 h-6 rounded"
      >
        <img
          [src]="config.icon"
          [alt]="config.title + ' icon'"
          class="w-6 h-6"
        />
      </div>
      <h3
        class="card-button__title m-0 text-subtitle-sm-bold sm:!text-md text-start text-titleText flex-1"
      >
        {{ config.title }}
      </h3>
    </div>

    <p
      class="card-button__description m-0 text-body-sm-regular md:text-base text-start !text-titleText"
    >
      {{ config.description }}
    </p>
  </div>
</button>
